import { render } from "./todo.html?vue&type=template&id=13a48dc8&scoped=true&ts=true"
import script from "./todo.ts?vue&type=script&lang=ts"
export * from "./todo.ts?vue&type=script&lang=ts"

import "./todo.scss?vue&type=style&index=0&id=13a48dc8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a48dc8"]])

export default __exports__